<div class="HeadImageContainer">
    <img [src]="(profile$ | async)?.avatar_url" class="ProfilePicture">
    <h1 class="PictureHeader">Dakoda Willden</h1>
    <h2 class="PictureText">Software Developer</h2>
</div>
<app-profile-summary title="{{summaryTitle}}" firstSectionText="{{summaryPart1}}" secondSectionText="{{summaryPart2}}" linkToCode="{{linkToCode}}"></app-profile-summary>

<iframe src="https://drive.google.com/file/d/1DUhZv2LirDACBK62IvDxtCSVCwslEUC5/preview" width="100%" height="480"></iframe>
<div class="spacing"></div>
